const image_carousels = document.querySelectorAll('.block--image-carousel .swiper-image-carousel')

if ( image_carousels.length > 0 ) {

  image_carousels.forEach((el, key) => {
    
    new Swiper(el, {
      slidesPerView:1,
      spaceBetween:30,
      arrows:true,
      loop:true,
      autoplay:true,
      delay:4000,
      simulateTouch:false,
      navigation:{
        nextEl:'.swiper-button-next',
        prevEl:'.swiper-button-prev',
      },breakpoints:{
        768:{
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024:{
          slidesPerView: 4,
          spaceBetween: 30,
        },
      }
    });

  })
}